import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa'; // Using react-icons for the up arrow icon


const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > window.innerHeight / 2) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <div
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-blue-500 text-white p-4 rounded-full cursor-pointer shadow-lg hover:bg-blue-700 transition-all duration-300"
        >
          <FaArrowUp size={24} />
        </div>
      )}
    </div>
  );
};

export default ScrollToTopButton;